import { Box, Divider, Grid, Typography } from "@mui/material";
import axios from "axios";

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BASE_URL } from "../../utils/BaseURL";
import ColorVariationsCard from "./ColorVariationsCard";
import SingleProductCard from "./SingleProductCard";
import SizeVariationsCard from "./SizeVariationsCard";
import BothVariationCard from "./BothVariationCard";
import { Select } from "antd";
import Filters from "./Filters";

let para =
  "Lorem ipsum dolor sit amet consectetur adipisicing elit.Quibusdam aliquid pariatur quae a, dolor distinctio,repudiandae deserunt porro magni nulla quo fugit mollitiaplaceat nemo nihil quaerat tempore voluptatem sint.";

const AllProducts = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState({
    color: "",
    rating: "",
    min_price: 10,
    max_price: 1000000,
  });

  const getData = () => {
    setIsLoading(true);
    let params = {};
    if (searchParams.get("sortBy"))
      params["sortBy"] = searchParams.get("sortBy");
    if (searchParams.get("min_price"))
      params["min_price"] = searchParams.get("min_price");
    if (searchParams.get("max_price"))
      params["max_price"] = searchParams.get("max_price");
    if (searchParams.get("rating"))
      params["rating"] = searchParams.get("rating");
    if (searchParams.get("color")) params["color"] = searchParams.get("color");

    axios
      .get(`${BASE_URL}/show/all`, {
        params,
      })
      .then((res) => {
        setProducts(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleAddParams = (obj) => {
    let params = {};
    for (const entry of searchParams.entries()) {
      params[entry[0]] = entry[1];
    }
    setSearchParams({ ...params, ...obj });
  };
  useEffect(() => {
    getData();
  }, [searchParams]);

  return (
    <Box style={{ padding: "40px" }}>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Typography variant="h4">Shop All Products</Typography>
        <Select
          style={{ width: "200px" }}
          name="sortBy"
          onChange={(val) => handleAddParams({ sortBy: val })}
          value={searchParams.get("sortBy") || "Sort By"}
        >
          {sortOptions?.map((option) => (
            <option key={option.name} value={option.value}>
              {option.name}
            </option>
          ))}
        </Select>
      </Box>
      <Divider></Divider>
      <Box style={{ display: "flex" }}>
        <Box style={{ width: "300px", padding: "10px" }}>
          <Filters
            filters={filters}
            setFilters={setFilters}
            handleAddParams={handleAddParams}
          />
        </Box>
        <Grid container spacing={2} style={{ padding: "40px" }}>
          {products?.length > 0
            ? products?.map((item, index) => {
                return item.productType == "Single" ? (
                  <SingleProductCard key={item._id} item={item} />
                ) : item.productType == "WithColor" ? (
                  <ColorVariationsCard key={item._id} item={item} />
                ) : item.productType == "WithSize" ? (
                  <SizeVariationsCard key={item._id} item={item} />
                ) : item.productType == "WithBoth" ? (
                  <BothVariationCard key={item._id} item={item} />
                ) : (
                  ""
                );
              })
            : "No Products Found"}
        </Grid>
      </Box>
    </Box>
  );
};

export default AllProducts;
const sortOptions = [
  { name: "All", value: "all", href: "#", current: true },
  { name: "Best Rating", value: "best_rating", href: "#", current: false },
  { name: "Newest", value: "newest", href: "#", current: false },
  {
    name: "Price: Low to High",
    value: "price_low_to_high",
    href: "#",
    current: false,
  },
  {
    name: "Price: High to Low",
    value: "price_high_to_low",
    href: "#",
    current: false,
  },
];
